module.exports = __webpack_public_path__ + "img/codeigniter.3765686c.svg";